import React, { useEffect, useState } from "react";
import useAuthStore from "../../data/stores/authStore";
import { useLocation, useNavigate } from "react-router";
import { AiOutlineMenu } from "react-icons/ai";
import { Icon } from "@iconify/react";
import Logo from "../layouts/logo";
import Avatar from "../../assets/icons/avatar.svg";
import Logout from "../../assets/icons/Vector.svg";
import { apiCall } from "../../data/useFetcher";
import { useRequestStore } from "../../data/stores/loggerStore";

const Sidebar = ({ children }) => {
	const { isAuth, logout, user } = useAuthStore(),
		{ getDynamicLogger, stat }: any = useRequestStore(),
		[nav, setNav] = useState(false),
		toggleNav = () => {
			setNav(!nav);
		},
		location = useLocation(),
		path = location?.pathname,
		navigate = useNavigate();

	useEffect(() => {
		apiCall({
			type: "get",
			url: `/api/v1/tools/new-request/stat`,
			getter: (d: any) => getDynamicLogger(d, "stat"),
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [location?.pathname]);

	console.log({ stat });

	let menu = [
			{ name: "tools", icon: "radix-icons:dashboard", path: "/tools" },
			{ name: "users", icon: "ph:users-three", path: "/users" },
			{ name: "Data", icon: "bxs:data", path: "/data" },
			{
				name: `Requests`,
				icon: "fluent:mail-20-regular",
				path: "/new-request",
				extra: `${stat && Number(stat) > 0 ? ` (${stat} New)` : ""}`,
			},
		],
		help = [
			{
				name: " general setting",
				icon: "icon-park-outline:setting-two",
				path: "/setting",
			},
			{
				name: "Privacy & Policy",
				icon: "ri:question-line",
				path: "/privacy",
			},
		];

	return (
		<div>
			<div>
				{isAuth && (
					<>
						<button
							onClick={toggleNav}
							className="inline-flex items-center p-2 mt-2 ml-3 text-sm text-gray-500 rounded-lg lg:hidden hover:text-green-200 focus:outline-none overflow-visible ">
							<span className="sr-only">Open sidebar</span>
							<AiOutlineMenu size={20} />
						</button>
						{/* Backdrop for mobile sidebar */}
						{nav && (
							<div
								className={`fixed lg:hidden top-0 left-0 z-40 w-full h-screen bg-black opacity-50`}
								onClick={toggleNav}></div>
						)}
						{/* Sidebar */}
						<aside
							className={`fixed shadow-sm top-0 left-0 z-50 w-64 bg-[#142239] h-screen pb-8 transition-transform transform ${
								nav ? "translate-x-0" : "-translate-x-full lg:translate-x-0"
							}`}>
							<div className="w-full relative">
								<div className="absolute top-6 left-6">
									<Logo type={"light"} />
								</div>
							</div>
							<div className="min-h-screen flex flex-col justify-between px-4 pt-28">
								<div>
									<p className="text-sm font-medium text-[#F1F5F9] inter mb-4">
										Menu
									</p>
									<div className="space-y-2">
										{menu?.map((m, i) => (
											<div
												key={i}
												onClick={() => navigate(m?.path)}
												className={`h-10 w-full ${
													path === m?.path || path?.includes(m?.path)
														? "bg-[#2563EB]"
														: "bg-transparent"
												} rounded-lg cursor-pointer flex gap-3 items-center px-4 hover:bg-[#2563EB]`}>
												<Icon
													icon={m?.icon}
													style={{
														fontSize: "24px",
													}}
													color="#F1F5F9"
												/>
												<span className="text-slate-100 capitalize font-medium text-base inter">
													{m?.name}
													{m?.extra ? (
														<>
															{" "}
															<span
																className={` ${
																	path === m?.path || path?.includes(m?.path)
																		? "text-[#142239]"
																		: "text-white"
																}`}>
																{m?.extra}
															</span>{" "}
														</>
													) : null}
												</span>
											</div>
										))}
									</div>
								</div>
								<div>
									<p className="text-sm font-medium text-[#F1F5F9] inter mb-4">
										Help
									</p>
									<div className="space-y-2">
										{help?.map((m, i) => (
											<div
												key={i}
												onClick={() => navigate(m?.path)}
												className={`h-10 w-full ${
													path === m?.path || path?.includes(m?.path)
														? "bg-[#2563EB]"
														: "bg-transparent"
												} rounded-lg flex gap-3 cursor-pointer items-center px-4 hover:bg-[#2563EB]`}>
												<Icon
													icon={m?.icon}
													style={{
														fontSize: "24px",
													}}
													color="#F1F5F9"
												/>
												<span className="text-slate-100 capitalize font-medium text-base inter">
													{m?.name}
												</span>
											</div>
										))}
									</div>
								</div>

								{/* User Info */}
								<div className="flex items-center mb-16 gap-2">
									<img
										src={user?.image?.url || Avatar}
										alt="User Profile"
										className="w-10 h-10 rounded-full"
									/>
									<div>
										<p className="text-base text-white font-semibold inter">
											{user?.firstName} {user?.lastName}
										</p>
										<p className="text-xs font-normal inter text-slate-300">
											{user?.email}
										</p>
									</div>
									<img
										src={Logout}
										onClick={logout}
										alt=""
										className="cursor-pointer"
									/>
								</div>
							</div>
						</aside>
					</>
				)}
				<div className={`${isAuth ? "lg:ml-[257px]" : ""}`}>
					<div>{children}</div>
				</div>
			</div>
		</div>
	);
};

export default Sidebar;
